import React from "react";
import {
  TableCell,
  TableRow,
} from "@mui/material";
import { ProductThumb } from "../dashboard/recent-order";
import { ApprovalStatusBadge } from "./approval-status-badge";
import { ApprovalActionsMenu } from "./approval-actions-menu";

export function ApprovalProductRow({ product, onViewProduct, onEditProduct }) {
  return (
    <TableRow
      sx={{
        "&:last-child td": { borderBottom: "none" },
        "& td": {
          borderColor: "#F0F0F0",
          py: 2,
          fontSize: "13px",
        },
      }}
    >
      <TableCell>
        <div className="flex items-center gap-3">
          <ProductThumb src={product.image} alt="" />
          <div className="min-w-0">
            <p className="my-0 truncate font-semibold text-[#1F2937]">
              {product.name}
            </p>
            <p className="my-0 mt-0.5 line-clamp-1 truncate text-[11px] font-medium text-[#9CA3AF]">
              {product.sku}
            </p>
          </div>
        </div>
      </TableCell>
      <TableCell>
        <span className="font-medium text-[#4B5563]">{product.category}</span>
      </TableCell>
      <TableCell>
        <span className="font-semibold text-[#1F2937]">{product.price}</span>
      </TableCell>
      <TableCell>
        <span className="tabular-nums font-medium text-[#374151]">
          {product.stock}
        </span>
      </TableCell>
      <TableCell>
        <span className="text-[13px] font-medium text-[#6B7280]">
          {product.dateSubmitted}
        </span>
      </TableCell>
      <TableCell align="center">
        <div className="flex justify-center">
          <ApprovalStatusBadge status={product.approvalStatus} />
        </div>
      </TableCell>
      <TableCell align="center">
        <div className="flex justify-center">
          <ApprovalActionsMenu
            product={product}
            onViewProduct={onViewProduct}
            onEditProduct={onEditProduct}
          />
        </div>
      </TableCell>
    </TableRow>
  );
}
